import http from '@/utils/http'

// 获取目录列表
export function getUrl(data) {
  return http({
    url: 'ahan/dir',
    method: 'post',
    data
  })
}

// 获取文件内容
export function getContent(data) {
  const url = data?.langtype === 5 ? 'ahannew/getcontent' : 'ahan/getcontent'
  return http({
    url,
    method: 'post',
    data
  })
}

// 获取历史版本藏文内容
export function getHistoryZWContent(data) {
  return http({
    url: 'ahannew/getvercontent',
    method: 'post',
    data
  })
}

// 搜索文件内容
export function getSearch(data) {
  return http({
    url: 'ahan/search',
    method: 'post',
    data
  })
}

// 提交藏文编辑
export function submitContent(data) {
  return http({
    url: 'ahannew/submit',
    method: 'post',
    data
  })
}

// 获取修订历史
export function getverlist(data) {
  return http({
    url: 'ahannew/getverlist',
    method: 'post',
    data
  })
}

// 增加批注
export function addComment(data) {
  return http({
    url: 'ahannew/addcomment',
    method: 'post',
    data
  })
}

// 删除批注
export function delComment(data) {
  return http({
    url: 'ahannew/delcomment',
    method: 'post',
    data
  })
}

// 编辑批注
export function editComment(data) {
  return http({
    url: 'ahannew/editcomment',
    method: 'post',
    data
  })
}
